import { useEffect } from 'react';
import { createIntl } from 'react-intl';

const MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

// Each of the following will be embedded in a separate HTML element in this order.
// The comment will be embedded in a comment element and each of the other two will
// be embedded into its own <script> element.
const COMMENT = ' Google tag (gtag.js) ';
const ASYNC_ELEMENT_SRC = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
const GTAG_ELEMENT_TEXT = [
  'window.dataLayer = window.dataLayer || [];',
  'function gtag(){dataLayer.push(arguments);}',
  'gtag("js", new Date());',
  `gtag('config', '${MEASUREMENT_ID}');`,
].join('');

/**
 * Embeds Google Analytics 4 script into <head> element of a page.
 */
export const useGA4 = () => {
  useEffect(() => {
    const asyncElement = document.createElement('script');
    asyncElement.async = true;
    asyncElement.src = ASYNC_ELEMENT_SRC;

    const gtagElement = document.createElement('script');
    const gtagElementTextNode = document.createTextNode(GTAG_ELEMENT_TEXT);
    gtagElement.appendChild(gtagElementTextNode);

    const commentElement = document.createComment(COMMENT);

    // Prepend in reverse order that elements should appear. When complete,
    // order will be comment, async element, and then the gtag element.
    document.head.prepend(gtagElement);
    document.head.prepend(asyncElement);
    document.head.prepend(commentElement);

    return () => {
      document.head.removeChild(commentElement);
      document.head.removeChild(asyncElement);
      document.head.removeChild(gtagElement);
    };
  }, []);
};

export const englishOnlyIntl = createIntl({ locale: 'en' });
